export default __webpack_public_path__ + "static/media/Countdown_3.61eeb657.svg";